import { takeEvery, put, select, take, call } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { consts as chatConsts } from '../../chatConnection';
import { consts as contextbar } from '../../ui/contextbar';
import { consts as popup, unassignedAction } from '../../ui/popup';

import { currentLocationSelector } from '../../common/selectors';
import {
  contextbarSelector,
  uiDrawerSelector,
  uiSidebarSelector,
} from '../../ui/selectors';
import {
  defaultFirstActiveChannel,
  defaultFirstContextUser,
} from '../selectors/channels';
import { consts as settings } from '../settings';
import { lastUserIdSelector } from '../selectors/settings';
import { removedContextUserIdSelector } from '../../circles/selectors';
import { removedMemberIdSelector } from '../selectors/removeParticipant';
import { loggedUserIdSelector } from '../../context/selectors';
import { isDesktop } from '../../../utils/mobileHelpers';
import { consts as drawer } from '../../ui/drawer';
import { consts as sidebar } from '../../ui/sidebar';

import {
  CIRCLE_OF_CARE,
  SURVEYS_GENERAL_SUB_PATH,
  PROGRAM,
  MESSAGES,
} from '../../../constants/routes';

function* showConfirmationPopup() {
  yield put(unassignedAction());

  yield take(popup.HIDE);
}

function* toggleMobileSidebars() {
  const drawerState = yield select(uiDrawerSelector);
  const sidebarState = yield select(uiSidebarSelector);

  if (!drawerState.visible) {
    yield put({ type: drawer.TOGGLE_VISIBILITY });
  }

  if (sidebarState.visible) {
    yield put({ type: sidebar.TOGGLE_VISIBILITY });
  }
}

function* toggleContextBar() {
  const contextBarState = yield select(contextbarSelector);

  if (contextBarState.visible) {
    yield put({ type: contextbar.RESET });
  }
}

function* clearChatId() {
  yield put({
    type: settings.CLEAR_CHAT_ID,
  });
}

function* setActiveUserChannel() {
  const firstChannelId = yield select(defaultFirstActiveChannel);
  const firstContextUser = yield select(defaultFirstContextUser);

  yield put({
    type: chatConsts.SET_ACTIVE_CHANNEL_ID,
    payload: firstChannelId,
  });

  if (firstContextUser) {
    yield put({
      type: settings.SET_LAST_USER_ID,
      payload: { id: firstContextUser },
    });
  }
}

function* removeContextUserWorker(action) {
  const {
    payload: { contextUserId },
  } = action;
  const currentLocation = yield select(currentLocationSelector);
  const lastUserId = yield select(lastUserIdSelector);
  const removedContextUserId = yield select(removedContextUserIdSelector);
  const removedMemberId = yield select(removedMemberIdSelector);
  const loggedUserId = yield select(loggedUserIdSelector);
  const contextLocation = [
    `/${CIRCLE_OF_CARE}/:id`,
    `/${SURVEYS_GENERAL_SUB_PATH}/:id`,
    `/${PROGRAM}/:id`,
    `/${MESSAGES}`,
  ].map(location => location.replace(':id', contextUserId));
  const showPopup =
    contextUserId === removedContextUserId || loggedUserId === removedMemberId;

  if (lastUserId !== contextUserId) {
    return;
  }

  if (contextLocation.includes(currentLocation)) {
    if (!showPopup) {
      yield call(showConfirmationPopup);
    }

    if (currentLocation !== `/${MESSAGES}`) {
      yield call(clearChatId);
      yield browserHistory.push(`/${MESSAGES}`);
    } else {
      yield call(toggleContextBar);
    }

    if (isDesktop()) {
      yield call(setActiveUserChannel);
    } else {
      yield call(toggleMobileSidebars);
    }
  } else {
    // Location not in the list
    yield call(clearChatId);
  }
}

export default function* removeContextUserSaga() {
  yield takeEvery([chatConsts.REMOVE_CONTEXT_USER], removeContextUserWorker);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/removeContextUser.js